export default __webpack_public_path__ + "static/media/Group52.f2944fcf.png";